import { render } from "./RWAWizard.vue?vue&type=template&id=6add30df"
import script from "./RWAWizard.vue?vue&type=script&lang=js"
export * from "./RWAWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__